<template>
  <div>
  </div>
</template>

<script>
import { userInfoMobile, AuthorizeMobile, WechatLogin } from '@/api/login.js'
// , IntoIndex
export default {
  components: {},
  props: {},
  data () {
    return {
      userFOM: {},
      openid: '',
      automaticLogin: '',
      indexs: ''
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 处理openid获取判断条件
    getFindeOpenId () {
      if (this.getQueryString('code') == null) {
        this.gotoAuth()
      } else {
        this.getInfo(this.getQueryString('code'))
      }
    },
    // 处理 获取openid 的 code
    getQueryString (name) {
      var url = window.location.search
      const start = url.indexOf(name + '=')
      const end = url.indexOf('/#/')
      if (start !== -1) {
        return decodeURIComponent(url.slice(start + name.length + 1, end))
      } else {
        return null
      }
      // const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      // const result = window.location.search.substring(1).match(reg)
      // if (result != null) {
      //   return decodeURIComponent(result[2])
      // }
      // return null
    },
    // 获取带有 code 的网址
    async gotoAuth () {
      const time = new Date().getTime() + Math.random().toFixed(6).slice(-6) + ''
      const { data: ress } = await AuthorizeMobile({
        returnUrl: location.href,
        state: time
      })
      if (ress !== '获取失败') {
        location.href = ress
      }
    },
    // 获取初始化参数
    async getInfo (code) {
      const { data: ress } = await userInfoMobile({
        code: code,
        state: location.href
      })
      // window.localStorage.setItem('TOKSCSAC', ress)
      if (ress.code === 1) return
      this.openid = ress.openId
      this.userFOM.headImgUrl = ress.headImgUrl
      this.userFOM.nickname = ress.nickname
      this.$store.commit('setOpenId', ress.openId)
      this.$store.commit('setIsAccessToken', this.userFOM)
      this.$store.commit('setVersionTime', new Date().getTime())
      this.$store.commit('setIsFirst', '1')
      this.WechatLogin(ress.openId)
    },
    async WechatLogin (e) {
      const { data: res } = await WechatLogin({ openId: e })
      if (res.length && this.automaticLogin !== 'yes') {
        this.$store.commit('setAccountList', res)
        res.forEach(async (item, index) => {
          if (item.isAuto === '0') {
            this.$store.commit('setUserID', item.userId + 'a')
            this.$store.commit('setToken', item.token)
            this.$store.commit('setUserName', item.userName)
            // const into = await IntoIndex()
            // window.open(into, '_self')
            return this.$router.push('/Home')
          } else {
            this.indexs = index
          }
          if (this.indexs === res.length - 1) {
            this.$router.push('/Login/no')
          }
        })
      } else {
        this.$router.push('/Login/no')
      }
    }
  },
  beforeCreate () {},
  created () {
    this.automaticLogin = this.$store.state.signOut ? this.$store.state.signOut : 'no'
    if (process.env.NODE_ENV !== 'production') {
      this.openId = 'oW9PG1CInaVEB5lzKD6pMqK45hu8'
      this.$store.commit('setOpenId', 'oW9PG1CInaVEB5lzKD6pMqK45hu8')
      this.$store.commit('setVersionTime', new Date().getTime())
      this.$store.commit('setIsFirst', '1')
      this.WechatLogin(this.openId)// 测试号
    } else {
      this.getFindeOpenId()
    }
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
</style>
